/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Decompose_DescInputs */

const es_prompt_tips_decompose_desc = /** @type {(inputs: Prompt_Tips_Decompose_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu consulta abarca muchos datos o pasos, dividila en partes más chicas. Podés usar las respuestas anteriores como contexto para las siguientes.`)
};

const en_prompt_tips_decompose_desc = /** @type {(inputs: Prompt_Tips_Decompose_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your query covers many data points or steps, split it into smaller parts. You can use previous answers as context for the next ones.`)
};

/**
* | output |
* | --- |
* | "If your query covers many data points or steps, split it into smaller parts. You can use previous answers as context for the next ones." |
*
* @param {Prompt_Tips_Decompose_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_decompose_desc = /** @type {((inputs?: Prompt_Tips_Decompose_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Decompose_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_decompose_desc(inputs)
	return en_prompt_tips_decompose_desc(inputs)
});
export { prompt_tips_decompose_desc as "prompt_tips.decompose_desc" }